export const GENERAL_INSIGHTS_PREFERENCES = 'WebApp.CampaignUI.GeneralInsightsPreferences';
export const FEATURE_NAME_GENERAL_INSIGHTS = 'GeneralInsightsGrid';
export const FEATURE_NAME_GENERAL_INSIGHTS_SHOPPING = 'GeneralInsightsShoppingGrid';

export const CAMPAIGN_TYPES = {
  Search: 'Default',
  Shopping: 'Shopping',
};

export const CAMPAIGN_TYPES_ENUM_VALUE = {
  [CAMPAIGN_TYPES.Search]: 1,
  [CAMPAIGN_TYPES.Shopping]: 2,
};

export const METRIC_PREFERENCE_KEY_NAME = {
  [CAMPAIGN_TYPES.Search]: 'selectedMetric',
  [CAMPAIGN_TYPES.Shopping]: 'shoppingSelectedMetric',
};

export const GENERAL_INSIGHTS_FEATURE_NAMES = {
  [CAMPAIGN_TYPES.Search]: FEATURE_NAME_GENERAL_INSIGHTS,
  [CAMPAIGN_TYPES.Shopping]: FEATURE_NAME_GENERAL_INSIGHTS_SHOPPING,
};
